// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"8e5c0402","453":"54292a4b","610":"dd850149","930":"9e2de0d9"}[chunkId] + ".chunk.js";
};